export enum Boards {
  a = "Board A",
  b = "Board B",
  c = "Board C",
  t = "Board T",
  "00" = "Board 00",
  r = "Board R",
}

export const BOARDS = Object.entries(Boards).map(
  ([key, value]) => ({ code: key, display: value })
);

export const BOARD_SWITH_SLIPS = Object.entries(Boards).filter(
  ([_, value]) => ([
    Boards.a,
    Boards.b,
    Boards.c,
    Boards.t,
    Boards["00"],
    Boards.r,
  ].includes(value))
).map(([key]) => key);